exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#schedule_page .container[data-v-79380151] {\n  max-width: 600px;\n}\n.el-col[data-v-79380151] {\n  margin-bottom: 10px;\n}\n.schedule-title[data-v-79380151] {\n  display: block;\n  font-size: 22px;\n  margin-bottom: 5px;\n}\n.schedule-daily-item[data-v-79380151] {\n  margin-bottom: 40px;\n}\n.form-item[data-v-79380151] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
